import { BaseFieldView } from '../BaseField/views';

export const SectionHeaderView = BaseFieldView.extend({
    // Override getTemplate to intercept BaseField getTemplate call
    getTemplate: function () {
        return '#tpl_section_header';
    },
    tagName: 'div', // we show the section field view as a header, not in the list
    className: 'section_header section_field'
});

export const SectionFieldView = BaseFieldView.extend({
    className: function () {
        return _.result(SectionFieldView.__super__, 'className') + ' section_field';
    }
});
